import React from 'react';
import ModificarPreguntaModal from '../../components/ModificarPreguntaModal';

const ModificarPreguntaModalPage = (props) => (
	<ModificarPreguntaModal {...props} />
);

export default ModificarPreguntaModalPage;
